// extracted by mini-css-extract-plugin
export default {"note":"AgreementWithButton-module__note--FC1QJ"};